import React from 'react';
import { FinancialAssistanceStatuses } from 'requisition-service-shared';
import { BillingType, getPaymentPlanOptions } from '@tempus/patient-forms-service-shared';
import FormSingleSelectDropdown from '../../../shared/form/FormSingleSelectDropdown';
import StripeWidget from '../../../../../components/StripeWidget';
import { required } from '../../../shared/form/validators';
import { createUseStyles } from 'react-jss';
import { GrayscalePalette } from '@tcl-boron-colors/colors';

const useStyles = createUseStyles({
  container: {
    padding: '16px',
    border: `1px solid ${GrayscalePalette[400]}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
});

type SelfPayPaymentPlanSubformProps = {
  faStatus: FinancialAssistanceStatuses | null;
  stripeCheckoutToken: string;
  setStripeComplete: (value: boolean) => void;
};

const SelfPayPaymentPlanSubform: React.FC<SelfPayPaymentPlanSubformProps> = ({
  faStatus,
  stripeCheckoutToken,
  setStripeComplete,
}) => {
  const classes = useStyles();
  const paymentPlanOptions = getPaymentPlanOptions(faStatus, BillingType.SELF_PAY);

  return (
    <div className={classes.container}>
      <FormSingleSelectDropdown
        name="numberOfInstallments"
        label="Number of Installments"
        placeholder="Select Payment Plan"
        validate={required}
        defaultValue={paymentPlanOptions[0]?.value}
        options={paymentPlanOptions as any}
        data-testid="self-pay-payment-plan-dropdown"
      />
      <StripeWidget
        onComplete={() => {
          setStripeComplete(true);
        }}
        checkoutSessionSecret={stripeCheckoutToken}
      />
    </div>
  );
};

export default SelfPayPaymentPlanSubform;
